// extracted by mini-css-extract-plugin
module.exports = {"title":"title-2JccdFmx clearfix","title_box":"title_box-3PzMAi5t","title_tg":"title_tg-2HLu2S1u"};